<template>
  <div v-if="training">
    <b-modal id="deleteTrainingModal" centered>
      <template #modal-header><h4>Usuwanie szkolenia</h4></template>
      Czy na pewno chcesz usunąć szkolenie {{training.name}}?
      <template #modal-footer>
        <vs-button type="border round" icon-pack="feather" icon="icon-x" @click="$bvModal.hide('deleteTrainingModal')">
          Anuluj
        </vs-button>
        <vs-button color="danger" icon-pack="feather" icon="icon-trash" type="filled round" @click="deleteTraining" class="mr-4">
          Usuń
        </vs-button>
      </template>
    </b-modal>
    <b-container fluid>
      <b-row class="mb-6 mt-6">
        <b-col><h4 class="mb-6">Dane szkolenia</h4></b-col>
        <b-col v-if="$acl.check('admin')">
          <vs-button type="filled round" icon-pack="feather" icon="icon-save"
                     v-if="!disabledForm" class="float-right ml-4" @click="updateTraining">
            Zapisz
          </vs-button>
          <vs-button type="border round" icon-pack="feather" :icon="disabledForm ? 'icon-edit-2' : 'icon-x'"
                     class="float-right" @click="toggleFormEdit">
            {{ disabledForm ? 'Edytuj' : 'Anuluj' }}
          </vs-button>
          <vs-button color="danger" type="border round" icon-pack="feather" icon="icon-trash"
                     v-if="disabledForm" class="float-right mr-4" @click="$bvModal.show('deleteTrainingModal')">
            Usuń
          </vs-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <vs-input
            label="Nazwa"
            v-model="training.name"
            class="w-100"
            :disabled="disabledForm"
          />
          <field-error :errorsBag="formErrors" fieldName="name"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <vs-input
            label="Opis"
            v-model="training.description"
            class="w-100 mt-4"
            :disabled="disabledForm"
          />
          <field-error :errorsBag="formErrors" fieldName="description"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-file
            v-model="training.thumbnail"
            placeholder="Wybierz zdjęcie szkolenia"
            drop-placeholder="Upuść tutaj"
            browse-text="Wybierz"
            class="w-100 mt-4"
            :disabled="disabledForm"
          />
          <field-error :errorsBag="formErrors" fieldName="thumbnail"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="mt-4">
          <p>Dla kogo:</p>
          <div v-for="(e, i) in employmentPositionItems" :key="i" class="ml-2 mb-6">
            <vs-checkbox v-model="e.state" class="w-100 mt-4" :disabled="disabledForm">{{ e.text }}</vs-checkbox>
          </div>
          <field-error :errorsBag="formErrors" fieldName="allowed_user_positions"/>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import {manageTraining} from "@/mixins/trainings/trainingsMixin"
import FieldError from "@/components/wod/forms/FieldError"

export default {
  name: 'TrainingDetails',
  mixins: [manageTraining],
  components:{
    FieldError
  },
  data () {
    return {
      formErrors: {},
      employmentPositionItems:
        [{
          text:'Lekarz',
          value:'lekarz'
        },
        {
          text:'Pracownik POZ',
            value:'pracownik POZ'
        },
        {
          text:'Pracownik instytucji pomocy społecznej',
            value:'pracownik instytucji pomocy społecznej'
        },
        {
          text:'Pracownik placówki edukacyjnej',
            value:'pracownik placówki edukacyjnej'
        }]
    }
  },
  computed: {
    allowedUserPositionList () {
      const positions = []
      this.employmentPositionItems.map(i => {
        if (i.state) positions.push(i.value)
      })
      return positions
    }
  },
}
</script>
